import * as React from 'react';
import { ModalFullscreen, ArticleParagraph1, Image, ArticleHeading2, IconClose16, IconButton } from '@cian/ui-kit';
import classNames from 'classnames';
import { Carousel } from '../../../../components/SimpleCarousel';
import * as styles from './styles.css';
import { IPins, TClusterMedia } from '../../../../types/cluster';

interface IStandardModalProps {
  open: boolean;
  onClose(visible: boolean): void;
  content: string;
  imageUrls: TClusterMedia[];
  pins?: IPins[];
  modalTitle: string;
  title: string;
}

export function ClusterModal({ open, onClose, content, imageUrls, title, modalTitle, pins }: IStandardModalProps) {
  return (
    <ModalFullscreen escape onClose={() => onClose(false)} open={open} theme="white">
      <div
        className={classNames(styles['container'], pins && styles['container--full-preview'])}
        data-testid="cluster_modal"
      >
        <div className={styles['header']}>
          <div className={styles['wrapper']}>
            <ArticleParagraph1>{modalTitle}</ArticleParagraph1>
            <div className={styles['close']}>
              <IconButton data-testid="standard_modal_close" icon={<IconClose16 />} onClick={() => onClose(false)} />
            </div>
          </div>
        </div>

        <div className={styles['content']}>
          <div className={styles['preview']}>
            {!pins && <Carousel slides={imageUrls} />}

            {pins && (
              <div className={styles['cluster-preview']}>
                <Image src={imageUrls[0].fullUrl} />
                {pins.map((pin, index) => (
                  <a
                    className={styles['pin']}
                    key={index}
                    href={pin.url}
                    style={{ ...pin.position }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {pin.name}
                  </a>
                ))}
              </div>
            )}
          </div>
          {(title || content) && (
            <div className={styles['info']}>
              <div className={styles['title']}>
                <ArticleHeading2>{title}</ArticleHeading2>
              </div>
              {content && <ArticleParagraph1>{content}</ArticleParagraph1>}
            </div>
          )}
        </div>
      </div>
    </ModalFullscreen>
  );
}
